import { createTypedSxStyles } from "@opengov/capital-mui-theme";

export const styles = createTypedSxStyles({
  root: {
    minHeight: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
  },
  wrapper: {
    flex: 1,
    minHeight: 0,
    display: "flex",
    overflow: "hidden",
  },
});
